/**
 * Variables section for defining linked table variables
 * Variables are named parameters with type and default value that can be
 * referenced in formulas ($name) and bound to filters (variable_name).
 */

import { Plus } from 'lucide-react';
import { Button } from '@loader/ui';

import { VariableCard } from './VariableCard';

import type { LinkedTableVariable } from '@/lib/types';


interface VariablesSectionProps {
  canEdit?: boolean;
  variables: LinkedTableVariable[];
  onAddVariable?: () => void;
  onUpdateVariable?: (variable: LinkedTableVariable) => void;
  onRemoveVariable?: (variableId: string) => void;
}

export function VariablesSection({
  canEdit = true,
  variables,
  onAddVariable,
  onUpdateVariable,
  onRemoveVariable,
}: VariablesSectionProps) {
  return (
    <div className="space-y-3">
      {variables.length === 0 && (
        <div className="text-muted-foreground py-4 text-center text-sm">
          No variables defined
        </div>
      )}

      {variables.map((variable) => (
        <VariableCard
          key={variable.id}
          variable={variable}
          canEdit={canEdit}
          onUpdate={onUpdateVariable}
          onRemove={onRemoveVariable}
        />
      ))}

      {/* Add button */}
      {canEdit && (
        <Button
          variant="outline"
          size="sm"
          className="w-full"
          onClick={onAddVariable}
        >
          <Plus className="mr-1.5 h-3.5 w-3.5" />
          Add Variable
        </Button>
      )}
    </div>
  );
}
